module.exports = __webpack_public_path__ + "static/media/reman-core-return-credit-screenshot.8aa37d1e.png";